import React from 'react';

export default function FAQ2(){
    return(
        <div className="question mt-40">
            <h4 className="h-4 h-bold">
                Invoices
            </h4>
            <div className="questions">
                <h6 className="h-6 bold-500 text-left">
                    How do I create an invoice?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    All you have to do is pick one of the templates, create or add your logo, and personalize the invoice according to your personal preference. Once that's done, enter the client's details and add items, and your invoice is ready!
                </p>
                <h6 className="h-6 bold-500 text-left">
                    How do I customize my invoices?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    You can customize the invoices from the settings. Choose the layout and add the company logo and any banners or watermarks of choice. You can change the overall look of your invoices by changing the colors.
                </p>
                <h6 className="h-6 bold-500 text-left">
                    How do I send my invoices?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    Invoice Point offers a range of options to send your invoices quickly and easily. You can send them via text and email, and also other methods, including Whatsapp and Facebook Messenger.
                </p>
            </div>
        </div>
    )
}